// extracted by mini-css-extract-plugin
export default {"content":"AthleteEffortDrawer_content__BYBkO","body":"AthleteEffortDrawer_body__EBfTZ","loading":"AthleteEffortDrawer_loading__qCywI"};